module.exports = __webpack_public_path__ + "static/media/moisture.9a2e4e07.svg";